<template>
  <div class="order-step">
    <next-prev-menu
      :disabled="error"
      :previous="true"
      title="Bestelling afronden"
      @next-step="submitOrder"
      @prev-step="$router.push({ name: 'printProductSecuredSAInvoice' })"
    ></next-prev-menu>
    <div class="card">
      <div class="confirm-card">
        <div class="card-2col">
          <deliver
            :order="order"
            :orderType="order.orderType"
            @addError="addError"
            @removeError="removeError"
            @goTo="$router.push({ name: 'printProductSecuredSADeliver' })"
          ></deliver>
          <invoice
            :order="order"
            @addError="addError"
            @removeError="removeError"
            @goTo="$router.push({ name: 'printProductSecuredSAInvoice' })"
          ></invoice>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card">
        <div class="confirm-card">
          <div class="title-container files-title">
            <h3 v-if="fileList.length > 0">
              {{ totalPrints }}
              <span v-if="totalPrints == 1">print</span>
              <span v-else>prints</span> van {{ fileList.length }} bestand<span
                v-if="fileList.length > 1"
                >en</span
              >
            </h3>
            <h3
              v-else
              class="error-text no-files-error pointer"
              @click="$router.push({ name: 'printProductSecuredSA' })"
            >
              Bestanden ontbreken nog, klik hier.
            </h3>
            <button
              class="white-pill-s right-btn"
              @click="$router.push({ name: 'printProductSecuredSA' })"
            >
              Bewerken
            </button>
          </div>

          <ul class="card-list print-file-list">
            <li class="" v-for="file in fileListSpecs" :key="file.fileName">
              <div class="filename-holder">
                <span class="file-name" :title="file.fileName"
                  ><span class="file-total bolder">{{ file.quantity }} x</span>
                  {{ file.fileName }}</span
                >
              </div>
              <div class="product-specs">
                <!-- <div class="product-title">
                <span>{{ file.productSpecs.title }}</span>
              </div> -->
                <div class="specs">
                  <span class="title">{{ file.product }}</span>
                  <span v-for="(value, name) in file.productSpecs" :key="name"
                    >{{ name }}: {{ value }}</span
                  >

                  <span
                    class="error-text pointer"
                    v-show="!file.product"
                    @click="$router.push({ name: 'printProductSecuredSA' })"
                  >
                    Nog geen product gekozen.
                  </span>
                </div>
              </div>
            </li>
          </ul>

          <div class="instruction-holder" v-if="order.instruction.length > 0">
            <div class="title-container">
              <h3 class="system-text">Instructies voor de printshop</h3>
            </div>
            <p class="instruction-text">{{ order.instruction }}</p>
          </div>
        </div>
        <div class="confirm-footer">
          <legal class="legal"></legal>

          <next-button
            label="Bestelling afronden"
            :disabled="error"
            :background-color="rootStore.theme.actionColor"
            :text-color="'white'"
            @click="submitOrder"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Deliver from '@/components/confirm/Deliver'
import Invoice from '@/components/confirm/Invoice'
import Legal from '@/components/confirm/Legal'
import { useFileListStore } from '@/stores/FileList.store'
import { EventBus } from '@/eventbus/EventBus'
import cloneDeep from 'lodash-es/cloneDeep'
import NextPrevMenu from '../../../components/NextPrevMenu.vue'
import { mapStores } from 'pinia'
import NextButton from '@/components/NextButton.vue'

import { usePrintProductSecuredSAStore } from '@/features/printProductSecuredSA/PrintProductSecuredSA.store'
import { next } from 'lodash-es'

export default {
  data() {
    return {
      totalPrints: 0
    }
  },
  components: {
    Deliver,
    Invoice,
    Legal,
    NextPrevMenu,
    NextButton
  },
  methods: {
    submitOrder() {
      EventBus.emit('submitOrder')
    },
    addError(val) {
      this.printProductSecuredSAStore.addOrderError(val)
    },
    removeError(val) {
      this.printProductSecuredSAStore.removeOrderError(val)
    }
  },
  computed: {
    ...mapStores(useFileListStore, usePrintProductSecuredSAStore),
    order() {
      return this.printProductSecuredSAStore.orderDetails
    },
    fileList() {
      return this.fileListStore.fileList
    },
    fileListSpecs() {
      const myObj = cloneDeep(this.fileList)
      myObj.forEach((file) => {
        if (file.productSpecs.title) {
          file.product = file.productSpecs.title
          delete file.productSpecs.title
        }
      })
      //delete myObj.title
      return myObj
    },
    error() {
      return this.printProductSecuredSAStore.orderErrors.length > 0
    }
  },
  created() {
    let prodErr = false

    this.fileList.forEach((element) => {
      this.totalPrints += parseInt(element.quantity)

      if (!element.productSpecs.title) {
        prodErr = true
      }
    })

    if (this.fileList.length < 1) {
      this.addError('productError')
    } else {
      this.removeError('productError')
    }

    if (prodErr) {
      this.addError('productError')
    } else {
      this.removeError('productError')
    }
  },
  watch: {
    fileList: function (val) {
      if (this.fileList.length < 1) {
        this.addError('productError')
      } else {
        this.removeError('productError')
      }

      let prodErr = false
      val.forEach((file) => {
        if (!file.productSpecs.title) {
          prodErr = true
        }
      })
      if (prodErr) {
        this.addError('productError')
      } else {
        this.removeError('productError')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.card .card-2col {
  min-height: auto;
}

.card .card-default {
  min-height: auto;
}

.card-list {
  margin-bottom: 10px;
}

.instruction-holder {
  margin: 10px 0;
  white-space: pre-line;
}

.print-file-list {
  li {
    margin-left: 13px;
    margin-right: 13px;
    padding: 4px 0;
  }
}

.filename-holder {
  text-overflow: ellipsis;
  overflow: hidden;

  padding: 4px 0;
}

.specs {
  margin: 4px -4px 7px;

  span {
    display: inline-block;
    margin: 5px;
    margin-right: 8px;
  }

  .error-text {
    margin-left: -8px;
  }
}

.title {
  font-weight: 600;
}
</style>
